"use client"

import { ChakraProvider } from "@chakra-ui/react"
import { Toaster } from "./toaster"
import { system } from "@/theme"
import { AppLocaleProvider } from "@/contexts/LocaleContext"
import {
  ColorModeProvider,
  type ColorModeProviderProps,
} from "./color-mode"

export function Provider(props: ColorModeProviderProps) {
  return (
    <ChakraProvider value={system}>
      <AppLocaleProvider>
        <ColorModeProvider enableSystem {...props} />
        <Toaster />
      </AppLocaleProvider>
    </ChakraProvider>
  )
}
